const getCachedWebsiteInfo = () => {
    try {
        const cached = localStorage.getItem('websiteDetails');
        return cached ? JSON.parse(cached) : {};
    } catch {
        return {};
    }
};

export default function getWebsiteData(state = {
    allCategories: [],
    websiteInfo: getCachedWebsiteInfo(),
    refreshCart: false,
    cartCount: 0,
    cartSubtotal: 0
}, action) {
    switch (action.type) {
        case "CATEGORIES":
            return {...state, allCategories: action.value };
        case "WEBSITE":
            return {...state, websiteInfo: action.value };
        case "REFRESH_CART_COUNT":
            return {...state, refreshCart: action.value };
        case "CART_COUNT":
            return {...state, cartCount: action.value };
        case "CART_SUMMARY":
            return {
                ...state,
                cartCount: action.value.count,
                cartSubtotal: action.value.subtotal,
            };
        default:
            return state;
    }
}
